module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-show": "$ctrl.isNewAvaiable()"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um público alvo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showgrid = !_vm.showgrid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova Atividade")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table b-table table-hover table-bordered b-table-stacked-md",
    attrs: {
      "role": "table",
      "aria-busy": "false",
      "aria-colcount": "7",
      "aria-rowcount": "-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_vm._l((_vm.propsObjetivos), function(objetivo, objetivoIndex) {
    return [_vm._l((objetivo.goals), function(meta, metaIndex) {
      return _vm._l((meta.activities), function(atividade, atividadeIndex) {
        return _c('tr', {
          attrs: {
            "role": "row"
          }
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "aria-colindex": "1",
            "data-label": "Meta",
            "role": "cell"
          }
        }, [_c('div', [_vm._v("\n                      " + _vm._s(meta.description) + "\n                    ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "aria-colindex": "2",
            "data-label": "Nome da atividade",
            "role": "cell"
          }
        }, [_c('div', [_vm._v("\n                      " + _vm._s(atividade.name) + "\n                    ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "aria-colindex": "3",
            "data-label": "Documento comprobatório",
            "role": "cell"
          }
        }, [_c('div', [_vm._v("\n                      " + _vm._s(atividade.supportingDocument) + "\n                    ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "aria-colindex": "4",
            "data-label": "Início",
            "role": "cell"
          }
        }, [_c('div', [_vm._v("\n                      " + _vm._s(atividade.startPeriod) + "\n                    ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "aria-colindex": "5",
            "data-label": "Fim",
            "role": "cell"
          }
        }, [_c('div', [_vm._v("\n                      " + _vm._s(atividade.finalPeriod) + "\n                    ")])]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "aria-colindex": "6",
            "data-label": "Ações",
            "role": "cell"
          }
        }, [_c('div', [_c('button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(atividade, meta)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exclui(meta, atividadeIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])])])])
      })
    })]
  })], 2)])])])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('meta')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "objective"
    }
  }, [_vm._v("Metas:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.meta),
      expression: "meta"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "meta"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.meta = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.metas), function(meta, index) {
    return _c('option', {
      domProps: {
        "value": meta
      }
    }, [_vm._v(_vm._s(meta.description))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('meta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('meta')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome da atividade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Nome da atividade: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atividadeForm.name),
      expression: "atividadeForm.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome da atividade",
      "id": "proposal-activity-name",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.atividadeForm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atividadeForm, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome da atividade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da atividade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Documento comprobatório')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Documento comprobatório: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atividadeForm.supportingDocument),
      expression: "atividadeForm.supportingDocument"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Documento comprobatório",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.atividadeForm.supportingDocument)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atividadeForm, "supportingDocument", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Documento comprobatório')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Documento comprobatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Período de início')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "measurementUnit"
    }
  }, [_vm._v("Período de início: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atividadeForm.startPeriod),
      expression: "atividadeForm.startPeriod"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:' + _vm.meses),
      expression: "'required|min_value:1|max_value:' + meses"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "Período de início",
      "type": "number",
      "min": "1",
      "ng-change": "addActivityCtrl.onChangePeriod(frmAddActivity.startPeriod, frmAddActivity.finalPeriod)"
    },
    domProps: {
      "value": (_vm.atividadeForm.startPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atividadeForm, "startPeriod", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Período de início')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Período de início')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Período de fim')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Período de fim: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addGoalCtrl.approval",
      "state": "addGoalCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atividadeForm.finalPeriod),
      expression: "atividadeForm.finalPeriod"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:' + _vm.meses),
      expression: "'required|min_value:1|max_value:' + meses"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "Período de fim",
      "type": "number",
      "min": "1",
      "ng-max": "addActivityCtrl.periods",
      "ng-change": "addActivityCtrl.onChangePeriod(frmAddActivity.startPeriod, frmAddActivity.finalPeriod)"
    },
    domProps: {
      "value": (_vm.atividadeForm.finalPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.atividadeForm, "finalPeriod", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Período de fim')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Período de fim')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-goal-add"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(_vm.meta, _vm.atividadeForm)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-goal-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {}, [_c('tr', [_c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "1"
    }
  }, [_vm._v("Meta")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "2"
    }
  }, [_vm._v("Nome da atividade")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "3"
    }
  }, [_vm._v("Documento comprobatório")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "4"
    }
  }, [_vm._v("Início")]), _vm._v(" "), _c('th', {
    staticClass: "sorting text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "tabindex": "0",
      "aria-colindex": "5"
    }
  }, [_vm._v("Fim")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center",
      "width": "13%"
    },
    attrs: {
      "aria-colindex": "6"
    }
  }, [_vm._v("Ações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f60caf14!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/atividadesOld.vue
// module id = 2109
// module chunks = 1